import { resolvePttProvider, type PttSidecarConfig } from "../pttSidecarClient";
import {
  PTT_AWS_SAMPLE_RATE_HZ,
  PTT_STT_PROMPT,
} from "./ptt/constants";

function defaultSidecarBaseUrl(): string {
  return import.meta.env.DEV ? "/voicebox" : "/api/voice/aws";
}

/** Core PTT audio backend. Dev → Voicebox proxy; production build → AWS voice API. */
export function pttSidecarConfig(): PttSidecarConfig {
  const baseUrl = defaultSidecarBaseUrl();
  const provider = resolvePttProvider(baseUrl, undefined);
  const sttModel = provider === "voicebox" ? "turbo" : "deepdml/faster-whisper-large-v3-turbo-ct2";
  const ttsModel =
    provider === "voicebox" ? "af_heart" : "speaches-ai/Kokoro-82M-v1.0-ONNX-fp16";

  return {
    baseUrl,
    provider,
    sttModel,
    ttsModel,
    ttsEngine: "kokoro",
    ttsProfileName: "og-orm-ptt",
    sttPrompt: PTT_STT_PROMPT,
    sampleRateHz: PTT_AWS_SAMPLE_RATE_HZ,
  };
}
